import memberships from 'modules/teams/store/collections/memberships'
import teams from 'modules/teams/store/collections/teams'
import { employeeTeams } from 'modules/teams/store/employeeTeams'

export const getSelectableTeams = (employeeId: string, canManageAllCompany: boolean) => {
  return canManageAllCompany ? teams : employeeTeams(teams, memberships, employeeId)
}
